import { getAuthHeader } from '@/modules/auth'
import { HttpClient } from './http-client/HttpClient'
import httpProvider from './http-provider'
import { AUTH0_SUS_AUDIENCE, CMD_URL } from '@/common/config'
import { ICMDCustomerResponse } from '@/types/types'

class CMDService extends HttpClient {
  public async getOpsCustomer(id: string): Promise<ICMDCustomerResponse> {
    return this.get(`/api/v1/ops_customers/${id}`, {
      headers: { 'x-org-id': id },
    })
  }
}

if (!CMD_URL) {
  throw new Error('CMD_URL not found')
}

export default new CMDService({
  httpProvider,
  getAuthHeader: async () => getAuthHeader({ audience: AUTH0_SUS_AUDIENCE }),
  baseURL: CMD_URL,
})
